import { getMoveInDateForMoveInForm } from '../../../sections/rentalPage/components/confirmation/helpers/ConfirmationSectionHelpers';

export const frameRequestForRentalInfoUnitCards = async (
  moveInDate: string,
  ledgerId: string,
  unitTypeId: string | number,
  gatsbyPathName: string,
  promoPlanData: any
) => {
  try {
    const source = gatsbyPathName.includes('move-in')
      ? 'Move_In'
      : 'Reservation';
    let framedReq: any = {};
    const MoveInDate = moveInDate
      ? moveInDate
      : getMoveInDateForMoveInForm(new Date());
    if (ledgerId || ledgerId !== '') {
      framedReq = {
        unit_type_id: unitTypeId,
        ledger_id: ledgerId,
        source: source,
        rental_info: {
          move_in_date: MoveInDate,
          period: 'Month',
          ...promoPlanData,
        },
      };
    } else {
      framedReq = {
        unit_type_id: unitTypeId,
        source: source,
        rental_info: {
          move_in_date: MoveInDate,
          period: 'Month',
          ...promoPlanData,
        },
      };
    }
    return framedReq;
  } catch (error) {
    console.error(
      'Error in frameRequestForRentalInfo in UnitCard Section',
      error
    );
  }
};
